import { render } from "./BusinessEntriesModal.vue?vue&type=template&id=80f4ca1a&scoped=true"
import script from "./BusinessEntriesModal.vue?vue&type=script&lang=js"
export * from "./BusinessEntriesModal.vue?vue&type=script&lang=js"

import "./BusinessEntriesModal.vue?vue&type=style&index=0&id=80f4ca1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80f4ca1a"]])

export default __exports__